import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/platform.css'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.use(ElementUI)
Vue.config.productionTip = false

// 页签缓存会停用页面组件；关闭挂载到 body 的弹窗，避免切页后旧单据遮挡新页面。
Vue.mixin({
  deactivated() {
    if (this.$options.name === 'ElDialog' && this.visible) {
      this.$emit('update:visible', false)
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
